export async function getCredentialsForIceServers() {
    const request = new Request(`${process.env.ROOT_URL}/credentials`, { method: 'GET' });
    const response = await fetch(request);
    if (!response.ok) {
        throw new Error(`Failed to fetch ICE credentials: ${response.statusText}`);
    }
    const credentials = await response.json();
    return credentials;
}
